import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import type WeekRange from 'bundles/degree-home/models/WeekRange';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/DisplayDate';

type Props = {
  weekRange: WeekRange;
};

class DisplayDate extends React.Component<Props> {
  render() {
    const { weekRange } = this.props;

    return (
      <h2 className="rc-DisplayDate degree-home-sub-heading" aria-live="assertive">
        <FormattedMessage message={_t('{date}')} date={weekRange.getFormattedDate()} />
      </h2>
    );
  }
}

export default DisplayDate;
